// extracted by mini-css-extract-plugin
export var videoHero = "_40-4";
export var videoHeroImage = "_40-5";
export var videoHeroOverlay = "_40-6";
export var videoHeroSubtitle = "_40-8";
export var videoHeroText = "_40-7";
export var videoLauncher = "_40-0";
export var videoLauncherIcon = "_40-1";
export var videoLauncherSubtitle = "_40-3";
export var videoLauncherTitle = "_40-2";
export var videoPlayer = "_40-a";
export var videoPlayerWrap = "_40-9";